// Fractional indexing на base62.
// keyBetween(a, b) возвращает строку строго между a и b (лексикографически).
// a == null → «от начала», b == null → «до конца». keyBetween(null, null) → середина шкалы.
// Ключи никогда не оканчиваются на '0', поэтому между любыми двумя всегда есть место.

const DIGITS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

export function keyBetween(a, b) {
  a = a || '';
  b = b || '';
  // Некорректная пара (a >= b) — защитный fallback: вставляем «после a»
  if (b !== '' && a !== '' && a >= b) b = '';
  let result = '';
  let i = 0;
  while (true) {
    const da = i < a.length ? DIGITS.indexOf(a[i]) : 0;
    let db;
    if (b === '' || i >= b.length) db = DIGITS.length;
    else db = DIGITS.indexOf(b[i]);
    if (da === db) { result += DIGITS[da]; i += 1; continue; }
    const mid = (da + db) >> 1;
    if (mid > da) return result + DIGITS[mid];
    // Соседние цифры: берём цифру a, дальше верхняя граница — конец шкалы
    result += DIGITS[da];
    b = '';
    i += 1;
  }
}

export const keyBefore = (b) => keyBetween(null, b);
export const keyAfter = (a) => keyBetween(a, null);

// Сортировка сиблингов: sortKey, задачи без ключа — в конец по createdAt.
export function compareSortKey(x, y) {
  if (x.sortKey && y.sortKey) return x.sortKey < y.sortKey ? -1 : x.sortKey > y.sortKey ? 1 : 0;
  if (x.sortKey) return -1;
  if (y.sortKey) return 1;
  return new Date(x.createdAt || 0) - new Date(y.createdAt || 0);
}
